import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fd2d5b42"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["muted"];
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 0,
  class: "controls-box"
};
const _hoisted_6 = {
  class: "time"
};
const _hoisted_7 = {
  class: "progress"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-button"
}, null, -1));
const _hoisted_9 = {
  class: "time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_slider = _resolveComponent("van-slider");
  return _openBlock(), _createElementBlock("div", {
    class: "video-box",
    onClick: _cache[7] || (_cache[7] = _withModifiers($event => $data.ifShow = !$data.ifShow, ["prevent"]))
  }, [_createElementVNode("div", null, [_createElementVNode("video", {
    ref: "video",
    loop: "",
    autoplay: "",
    controls: false,
    preload: "auto",
    "x5-playsinline": "true",
    "x5-video-player-type": "h5-page",
    "webkit-playsinline": "true",
    playsinline: "true",
    muted: $data.ifMuted
  }, [_createElementVNode("source", {
    src: $data.src
  }, null, 8, _hoisted_2)], 8, _hoisted_1), _withDirectives(_createElementVNode("div", {
    class: "video-cover",
    style: _normalizeStyle(`background-image: url('${$data.img_url}')`)
  }, [_createElementVNode("img", {
    class: "play-icon",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.videoPlay && $options.videoPlay(...args), ["stop"])),
    src: "https://s.moimg.net/m/images/video-play.png"
  })], 4), [[_vShow, $data.showPlayIcon]]), _createElementVNode("div", {
    class: "back-icon",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goBack && $options.goBack(...args))
  }, _hoisted_4), $data.ifShow && !$data.showPlayIcon ? (_openBlock(), _createElementBlock("div", _hoisted_5, [$data.ifPlay ? (_openBlock(), _createElementBlock("i", {
    key: 0,
    class: "control",
    style: _normalizeStyle(`background-image: url(${require('@assets/images/common/video_pause.png')})`),
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.play(false), ["stop"]))
  }, null, 4)) : (_openBlock(), _createElementBlock("i", {
    key: 1,
    class: "control",
    style: _normalizeStyle(`background-image: url(${require('@assets/images/common/video_play.png')})`),
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $options.play(true), ["stop"]))
  }, null, 4)), _createElementVNode("div", _hoisted_6, _toDisplayString($options.formatTime($data.currentTime)), 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_slider, {
    modelValue: $data.currentTime,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.currentTime = $event),
    "active-color": "#00C4A1",
    "bar-height": "3px",
    max: $data.duration,
    onChange: $options.onChange
  }, {
    button: _withCtx(() => [_hoisted_8]),
    _: 1
  }, 8, ["modelValue", "max", "onChange"])]), _createElementVNode("div", _hoisted_9, _toDisplayString($options.formatTime($data.duration)), 1), $data.ifMuted ? (_openBlock(), _createElementBlock("i", {
    key: 2,
    class: "voice",
    style: _normalizeStyle(`background-image: url(${require('@assets/images/common/video_muted.png')})`),
    onClick: _cache[5] || (_cache[5] = _withModifiers($event => $options.muted(false), ["stop"]))
  }, null, 4)) : (_openBlock(), _createElementBlock("i", {
    key: 3,
    class: "voice",
    style: _normalizeStyle(`background-image: url(${require('@assets/images/common/video_voice.png')})`),
    onClick: _cache[6] || (_cache[6] = _withModifiers($event => $options.muted(true), ["stop"]))
  }, null, 4))])) : _createCommentVNode("", true)])]);
}